var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('loading-spinner',{staticClass:"h-12 w-12",attrs:{"is-loading":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }